export const DOCUMENT_SUCCESS = 'DOCUMENT_SUCCESS'
export const DOCUMENT_FAILURE = 'DOCUMENT_FAILURE'

export const documentData = (document) =>{
  return (dispatch, getState) => {
    dispatch({ type: DOCUMENT_SUCCESS, document });
  }
}
